import React from 'react';
import styled from 'styled-components'

const Title = styled.div`
    font-size : 1.75em;
    font-weight : bold;
    color:black;
`;

const PageTitle =({ title }) => (
    <Title>{title}</Title>
);

export default PageTitle;